import React from 'react';
import { OTHER_DISEASE } from 'utils/constants/disease';
import app from 'new-ui/app';
import { useTranslation } from 'utils/modifiedTranslation';
import { useProviderSpecificConfiguration } from 'modules/appConfiguration/useProviderSpecificConfiguration';
import { useMatchesFilterLocation } from 'modules/matchesFilter/MatchesFilterContext';
import { useSetHeaderSettings } from 'components/PageHeader/PageHeaderContext';
import { TAB_IDS } from 'components/PageHeader/constants';
import './Treatment.css';
import AiAssistant from 'new-ui/Components/AiAssistent';
import { getUserCondition, isNewlyDiagnosedUser } from 'modules/user/utils';
import { StickyContainer } from 'new-ui/Components/StickyContainer';
import { TreatmentOptionsGuide } from 'new-ui/Components/TreatmentOptionsGuide';
import { useIsMobileResolution } from 'utils/hooks/useIsMobileResolution';
import { POPUP } from 'utils/constants/popup';
import { hasUserSponsoredTrials } from 'new-ui/functions';
import Nba from 'new-ui/NBA/Nba';
import { Widgets } from './Widgets';
import { CustomerRefUserWidgets } from './CustomerRefUserWidgets';
import { FEED_GA } from './constants';

const openShareWithDoctorPopup = () => {
  app.setPopup(POPUP.SHARE_WITH_MY_DOCTOR);
};

const openCallUsPopup = () => {
  app.setPopup(POPUP.CALLUS, {
    CSS: {
      width: '600px',
    },
  });
};

const getStickyWidgetStyle = ({ isMobile }) => {
  const style = {
    paddingTop: isMobile ? '0px' : '44px',
    top: '-350px',
  };
  return style;
};

export const Feed = () => {
  const { t } = useTranslation();
  useMatchesFilterLocation();

  const { symptomCareDisabled } = useProviderSpecificConfiguration();
  const isMobileResolution = useIsMobileResolution();

  useSetHeaderSettings({
    isProfileButtonShown: true,
    isBurgerMenuShown: true,
    isUploadButtonShown: true,
    tabIds: [
      TAB_IDS.FEED,
      TAB_IDS.TREATMENT_OPTIONS,
      TAB_IDS.SUPPORT_PROGRAMS,
      ...(symptomCareDisabled ? [] : [TAB_IDS.SYMPTOM_CARE]),
      ...(isNewlyDiagnosedUser(app?.user) ? [TAB_IDS.ARTICLES] : []),
      TAB_IDS.SPEAK_WITH_TINA,
    ],
  });

  const welcome = () => `${t('feed.title.main')}${app.user.info.family_name ? `, ${app.user.info.family_name}!` : ''}`;

  const { personal: { customerRef } = {} } = app.user || {};
  const condition = getUserCondition(app.user);

  return (
    <div className="feed-page">
      <h2 className="welcome welcome-mobile">{welcome()}</h2>
      <div className="feed-page-container">
        <h2 className="welcome">{welcome()}</h2>
        {condition !== OTHER_DISEASE && <div className="nba-on-feed-page-wrapper"><Nba /></div>}
        {customerRef ? (
          <CustomerRefUserWidgets />
        ) : (
          <Widgets />
        )}
      </div>
      {condition !== OTHER_DISEASE && (
        <div className="feed-sidebar">
          <StickyContainer
            style={getStickyWidgetStyle({ isMobile: isMobileResolution })}
          >
            <TreatmentOptionsGuide
              onClickShare={openShareWithDoctorPopup}
              onClickTalk={openCallUsPopup}
              sponsoredUser={hasUserSponsoredTrials()}
            />
            <AiAssistant
              onUploadClick={() => {
                app.sendGoogleAnalyticsEvent(FEED_GA.category, FEED_GA.events.fileUploadClicked);
              }}
              onEditClick={() => {
                app.sendGoogleAnalyticsEvent(FEED_GA.category, FEED_GA.events.answerManuallyClicked);
              }}
            />
          </StickyContainer>
        </div>
      )}
    </div>
  );
};
